import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import Button from "../../../../../../../ui/Button";
import InfoField from "../../../../../../../ui/InfoDrawer/components/InfoField";
import DataSelect from "../../../../../../../ui/DataSelect";
import TextField from "@material-ui/core/TextField";

const DialogTitle = withStyles(theme => ({
  root: {
    color: "#778899",
    "& > h2": {
      fontSize: 12
    }
  }
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

export default function ProgramDialog({
  showThemeDialog,
  closeThemeDialog,
  type,
  title,
  moduleAbility,
  theme,
  changeAbility,
  changeTheme,
  addModuleThemeVolume,
  activeVolumeId,
  updateModuleTheme,
  activeThemeId
}) {
  const addTheme = () => {
    const moduleVolumeTheme = {
      volumeId: activeVolumeId,
      main: {
        number: theme.main.number,
        name: theme.main.name
      },
      abilities: theme.ability.map(item => item.id)
    };
    addModuleThemeVolume(moduleVolumeTheme);
    closeThemeDialog();
  };

  const updateTheme = () => {
    const moduleVolumeTheme = {
      volumeId: theme.volumeId,
      main: {
        number: theme.main.number,
        name: theme.main.name
      },
      abilities: theme.ability.map(item => item.id)
    };
    updateModuleTheme(activeThemeId, moduleVolumeTheme);
    closeThemeDialog();
  };

  return (
    <div>
      <Dialog open={showThemeDialog}>
        <div>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Grid container justify="space-between">
              <Grid item xs={2}>
                <TextField
                  name="number"
                  required
                  label="Номер"
                  value={theme.main.number}
                  onChange={changeTheme}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="name"
                  required
                  label="Наименование"
                  value={theme.main.name}
                  onChange={changeTheme}
                  InputLabelProps={{
                    shrink: true
                  }}
                  style={{ width: "100%" }}
                />
              </Grid>
              <InfoField name="Формируемые умения/знания/ПК" />
              <DataSelect
                multiple
                dataSource={moduleAbility || []}
                getOptionLabel={option => `${option.code} | ${option.note}`}
                value={theme.ability}
                onChange={value => changeAbility("ability", value)}
                disableClearable={false}
                filterSelectedOptions={true}
                label=""
              />
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={closeThemeDialog}>Отмена</Button>
            <Button
              onClick={() => (type === "add" ? addTheme() : updateTheme())}
              color="green"
            >
              {type === "add" ? "Добавить" : "Обновить"}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}
